var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../../core/runtime/src';
import { KeyCode } from '../../../../core/utils/src/dom';
import LegacyClassBuilder from '../../../../core/utils/src/class-builders/legacy';
import { Checkbox } from '../../../checkbox/src';
import { RadioButton } from '../../../radio/src';
export default function SelectionControl(_a) {
    var Wrapper = _a.wrapper, name = _a.name, wrapperProps = _a.wrapperProps, baseClassName = _a.baseClassName, itemId = _a.itemId, selectionType = _a.selectionType, checked = _a.checked, disabled = _a.disabled, _b = _a.indeterminate, indeterminate = _b === void 0 ? false : _b, onClick = _a.onClick, onShiftToggle = _a.onShiftToggle, _c = _a.onFocusUp, onFocusUp = _c === void 0 ? function () { } : _c, _d = _a.onFocusDown, onFocusDown = _d === void 0 ? function () { } : _d;
    var isMultiSelection = selectionType === "multi" /* MULTI */;
    var onWrapperClick = function (event) {
        var target = event.target;
        // Focus on the native input element when the selection area or the input field is clicked
        var nativeInput = target.querySelector('input') || target;
        nativeInput.focus();
        // If a div and an input (in this case, a checkbox) are placed inside a
        // label element both of them fire the `click` event.
        if (target.tagName.toLowerCase() === Wrapper) {
            if ((isMultiSelection || !checked) && !disabled) {
                onClick(event);
            }
        }
    };
    var wrapperClassName = new LegacyClassBuilder({ __componentName: baseClassName })
        .addComponentClass('selection-area')
        .addComponentClass('selection-area-disabled', disabled)
        .toClassName();
    var properties = __assign(__assign({}, wrapperProps), { className: wrapperClassName, onclick: onWrapperClick, onmousedown: function (event) {
            onShiftToggle(event.shiftKey);
            //prevents shift-clicks from selecting text
            event.preventDefault();
        } });
    if (isMultiSelection) {
        // native checkboxes do not have focus move via keyboard, we implement it here programmatically
        properties.onkeydown = function (event) {
            onShiftToggle(event.shiftKey);
            if (event.keyCode === KeyCode.up) {
                event.preventDefault();
                onFocusUp();
            }
            if (event.keyCode === KeyCode.down) {
                event.preventDefault();
                onFocusDown();
            }
        };
    }
    var attrs = {
        className: "awsui-table-selection-trigger checkbox-index-" + itemId,
        ariaLabelledby: name + "-selection-group " + name + "-selection-" + itemId,
        change: function (evt) {
            evt.stopPropagation();
            onClick();
        },
        checked: checked,
        disabled: disabled,
        indeterminate: indeterminate
    };
    var selector = isMultiSelection ? AwsUi.__createElement(Checkbox, __assign({}, attrs)) : AwsUi.__createElement(RadioButton, __assign({ name: name }, attrs));
    return AwsUi.__createElement(Wrapper, __assign({}, properties), selector);
}
//# sourceMappingURL=selection-control.js.map